import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { AppThunk } from '../store'
import { HTTP } from '../lib/axios'
import { LoadingPayload, CommunicationsLoadingState } from '../types/common'
import { sortListByDate } from '../utils/common'
import { Communication } from '../types/communication'

export interface CommunicationsState {
  loading: CommunicationsLoadingState
  communications: Array<Communication>
}
export const initialState: CommunicationsState = {
  loading: {
    communications: false,
    updating: false
  },
  communications: [],
}

const communicationsSlice = createSlice({
  name: 'communications',
  initialState,
  reducers: {
    setLoading: (state, { payload }: PayloadAction<LoadingPayload>) => {
      const clone = { ...state.loading, [payload.type]: payload.payload }
      state.loading = clone
    },
    setCommunications: (state, { payload }: PayloadAction<Array<Communication>>) => {
      state.communications = sortListByDate(payload, 'dateCreated', true)
    },
    updateCommunication: (state, { payload }: PayloadAction<Communication>) => {
      const clone = [...state.communications]
      const existing = clone.findIndex((comm) => comm.communicationId === payload.communicationId)
      if (existing > -1) {
        clone[existing] = payload
      } else {
        clone.unshift(payload)
      }
      state.communications = clone
    }
  }
})

export const {
  setLoading,
  setCommunications,
  updateCommunication
} = communicationsSlice.actions
export default communicationsSlice.reducer
export const communicationsSelector = (state: { communicationsStore: CommunicationsState }) => state.communicationsStore

export const getCommunications = (token: string, accountId: string, australisId: string): AppThunk => {
  return async (dispatch) => {
    dispatch(setLoading({ type: 'communications', payload: true }))
    try {
      const res = await HTTP.get(`/communications/${accountId}/user/${australisId}/communication`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      dispatch(setCommunications(res.data.communications))
      dispatch(setLoading({ type: 'communications', payload: false }))
    } catch (err) {
      console.log(err)
      dispatch(setLoading({ type: 'communications', payload: false }))
    }
  }
}

export const postCommunication = (token: string, accountId: string, australisId: string, communicationId: string, payload: any): AppThunk => {
  return async (dispatch) => {
    dispatch(setLoading({ type: 'updating', payload: true }))
    try {
      const res = await HTTP.post(`/communications/${accountId}/user/${australisId}/communication/${communicationId}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      dispatch(updateCommunication(res.data.communication))
      dispatch(setLoading({ type: 'updating', payload: false }))
    } catch (err) {
      console.log(err)
      dispatch(setLoading({ type: 'updating', payload: false }))
    }
  }
}
